var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { to } from "@lib/utils";
import { get, post } from "./api";
export const createTransaction = (captureStatus, values, // react-hook-form watch() values
customId, invoiceId, selectedTicket, user, lang) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    console.log(values);
    const contactInfos = Object.keys(values)
        .filter((v) => v !== "agreement")
        .reduce((acc, curr) => {
        const i = curr.split("-")[0];
        const input = curr.split("-")[1];
        if (!input)
            return acc;
        const value = values[curr];
        const index = acc.findIndex((v) => v["id"] === i);
        if (index < 0) {
            acc.push({ id: i, [input]: value });
        }
        else {
            acc[index][input] = value;
        }
        return acc;
    }, []);
    const ticket = selectedTicket.ticket;
    const { err, res: data } = yield to(post(`/transactions/create`, {
        id: customId,
        ticketId: ticket.id,
        emails: contactInfos.map((c) => c.emailAddress),
        discountCodeId: ((_a = selectedTicket.discount) === null || _a === void 0 ? void 0 : _a.id) || null,
        refIds: {
            invoiceId: invoiceId,
        },
        contactInfos: contactInfos,
        price: selectedTicket.payablePerTicket,
        captureStatus: captureStatus,
        buyer: user.email,
        walletAddress: values.walletAddress || user.walletAddresses[0],
        locale: lang,
        priceId: ticket.currentPriceId,
        userId: user.id,
        quantity: selectedTicket.quantity,
    }));
    if (err || !data) {
        return [false, null];
    }
    return [true, data];
});
export const getTransactionByEmail = (email) => __awaiter(void 0, void 0, void 0, function* () {
    const { err, res: data } = yield to(get(`/transactions/all?email=${email}`));
    if (err || !data)
        return [];
    return data;
});
const _transformEmailAddr = (email) => {
    return email.toLowerCase().replace(/\+.*@/g, "@");
};
export const hasTransactionByEmail = (email) => __awaiter(void 0, void 0, void 0, function* () {
    if (email.length === 0) {
        return false;
    }
    const { err, res: data } = yield to(getTransactionByEmail(_transformEmailAddr(email)));
    if (err || !data)
        return false;
    return data.length === 0;
});
export const updateTransactionStatusByCustomId = (customId, captureStatus, error) => __awaiter(void 0, void 0, void 0, function* () {
    console.log("updateTransactionStatusByCustomId error:", error);
    const { err, res: data } = yield to(post(`/transactions/${customId}`, { captureStatus, errorMessage: error }));
    if (err || !data)
        return false;
    return true;
});
